import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { config } from '@/environment';
import { ROUTES } from '@/routes/Routes';

export default function useCypressScreenshotRedirect() {
  const navigate = useNavigate();
  const caseId = config.CYPRESS_SCREENSHOT;

  useEffect(() => {
    if (!caseId) return;
    // NOTE: the code generated by the script "createAccessLink" is always "cypress"
    navigate(`${ROUTES.ACCESS_LINK}/cypress`);
  }, [navigate, caseId]);
}
